import IconButton from "components/Button/IconButton";
import NotFound from "components/not-found/NotFound";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Pagination from "react-js-pagination";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ModalBox from "components/modal/ModalBox";
import { useNavigate } from "react-router-dom";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import { Button } from "components/Button/Button";
import { Input, TextArea } from "components/Form";
import toast from "react-hot-toast";
import {
  AddAccessIpAddress,
  DeleteAccessIpAddress,
  DeleteBulkAccessIpAddress,
  getIPAccessList,
  UpdateAccessIpAddress,
} from "services/IPAccessManagement";
import { dateFormat, dateTimeFormat, dateipFormat } from "utils";
import { Checkbox, Fab, FormControlLabel } from "@mui/material";
import { getUserIpAddress } from "services/auth";
import { RemoveRedEye } from "@mui/icons-material";
import SpeedDial from "components/speed-dial/SpeedDial";

export default function IpAccessList() {
  const navigate = useNavigate();
  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [selectedId, setSelectedId] = useState("");

  const [addModal, setAddModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [data, setData] = useState({});
  const [comment, setComment] = useState("");
  const [errorField, setErrorField] = useState({});
  const [flag, setFlag] = useState(false);

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  //   ************************************* Fetch Records *******************************************
  const fetchRecord = async () => {
    showLoader();
    try {
      const res = await getIPAccessList({
        page: activePage,
        // search: search,
        // limit: pageLimit,
      });
      hideLoader();
      if (res.code === 200) {
        const { rows, count } = res.data.ipaccesslist;
        setRecord(rows || []);
        setTotal(count || 0);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    fetchRecord();
  }, [activePage]);

  //   *************************************** fetch IP Address ***********************************************
  useEffect(() => {
    if (flag) {
      (async () => {
        try {
          const response = await getUserIpAddress();
          setData({ ...data, address: response.data.ip });
        } catch (error) {
          console.error("Error fetching IP:", error);
        }
      })();
    } else {
      setData({ ...data, address: "" });
    }
  }, [flag]);

  //   ******************************************* Handle Validation ***************************************************
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    if (!data.address) {
      errorField["address"] = "Please Enter IP Address";
      formIsValid = false;
    }
    if (!data.name) {
      errorField["name"] = "Please Enter Name";
      formIsValid = false;
    }
    
    setErrorField(errorField);
    return formIsValid;
  };
  
  //   ******************************************* Handle Add Ip Submit ***************************************************
  const handleAddIpSubmit = async () => {
    if (handleValidation()) {
      showLoader();
      try {
        const res = await AddAccessIpAddress({
          name: data.name,
          ipaddress: data.address,
          comment: data.comment,
        });
        hideLoader();
        if (res.code === 200) {
          toast.success(res.message);
          setAddModal(false);
          fetchRecord();
          setData({})
          setFlag(false);
        } else {
          setData({})
          setAddModal(false);
          fetchRecord();
          setFlag(false);
          toast.error(res.message);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
      }
      hideLoader();
    }
  };

  //   ******************************************* Handle Update Ip Submit ***************************************************
  const handleUpdateIpSubmit = async () => {
    if (handleValidation()) {
      showLoader();
      try {
        const res = await UpdateAccessIpAddress({
          id:data.id,
          name: data.name,
          ipaddress: data.address,
          comment: data.comment,
        });
        hideLoader();
        if (res.code === 200) {
          toast.success(res.message);
          setUpdateModal(false);
          setData({})
          fetchRecord();
          setFlag(false);
        } else {
          setUpdateModal(false);
          setData({})
          fetchRecord();
          setFlag(false);
          toast.error(res.message);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
      }
      hideLoader();
    }
  };

  //   *********************************** Handle Ip delete **********************************************
  const handleIpDelete = async () => {
    showLoader();
    try {
      if (data.id) {
        const res = await DeleteAccessIpAddress({
          id: data.id,
        });
        hideLoader();
        if (res.code === 200) {
          toast.success(res.message);
          setDeleteModal(false);
          fetchRecord();
        } else {
          toast.error(res.message);
          setDeleteModal(false);
          fetchRecord();
        }
      } else {
        const res = await DeleteBulkAccessIpAddress({
          id: selectedId, // Pass the comment
        });
        hideLoader();
        if (res.code === 200) {
          toast.success(res.message);
          setDeleteModal(false);
          fetchRecord();
        } else {
          toast.error(res.message);
          setDeleteModal(false);
          fetchRecord();
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };

  // *************************************** Handle Checkbox selection **************************************************
  const checkUncheckAll = () => {
    if (selectedId.length > 0 && selectedId.length === record.length) {
      setSelectedId([]);
    } else {
      setSelectedId(record.map((data) => data.id));
    }
  };

  const checkHandler = (id) => {
    showLoader();
    if (selectedId.includes(id)) {
      setSelectedId(selectedId.filter((data) => data !== id));
    } else {
      setSelectedId([...selectedId, id]);
    }
    hideLoader();
  };

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap">
                <div className="SearchBox mt-1">
                  {/* <div style={{ marginRight: "10px" }}>
                    <Input
                      className={"form-control"}
                      placeholder="Search Here"
                      value={search}
                      onChange={({ target }) => setSearch(target.value)}
                      type="text"
                    />
                  </div> */}
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Button
                      style={{ marginRight: "10px" }}
                      onClick={() => {
                        setAddModal(true);
                      }}
                    >
                      Add IP Address
                    </Button>
                  </div>
                </div>
              </div>
              <h4 className="Title">IP Access List</h4>
            </div>

            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th style={{ width: "40px" }}>
                      {record.length > 0 && (
                        <Checkbox
                          size="small"
                          sx={{
                            padding: "0",
                            "& .MuiSvgIcon-root": {
                              color: "#e14177", // Apply color to the checkmark
                            },
                            background: "#fff",
                            borderRadius: "0",
                          }}
                          onChange={checkUncheckAll}
                          checked={selectedId.length === record.length}
                        />
                      )}
                    </th>

                    <th>S.No</th>
                    <th>Name</th>
                    <th>Ip Address</th>
                    <th>Date And Time</th>
                    <th className="text-center">Comment</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      ({ id, name, ipaddress, addedon, comment }, i) => (
                        <tr key={i}>
                          <td>
                            <Checkbox
                              size="small"
                              sx={{
                                padding: "0",
                                "& .MuiSvgIcon-root": {
                                  color: "#e14177", // Apply color to the checkmark
                                },
                              }}
                              checked={selectedId.includes(id)}
                              onChange={() => checkHandler(id)}
                            />
                          </td>
                          <td style={{ width: "100px" }}>
                            {++i + (activePage - 1) * 1}
                          </td>
                          <td>{name}</td>
                          <td>{ipaddress}</td>
                          <td>{dateipFormat(addedon)}</td>
                          <td>
                            <div className="d-flex justify-content-center">
                              <IconButton
                                aria-label="view"
                                className="px-1 py-0"
                                onClick={() => {
                                  setCommentModal(true);
                                  setComment(comment || "");
                                }}
                              >
                                <RemoveRedEye sx={{ color: "#4971B2" }} />
                              </IconButton>
                            </div>
                          </td>
                          <td style={{ width: "100px" }}>
                            <div className="d-flex justify-content-center">
                              <IconButton
                                aria-label="view"
                                className="px-1 py-0"
                                onClick={() => {
                                  setUpdateModal(true);
                                  setData({
                                    id,
                                    address: ipaddress,
                                    name,
                                    comment,
                                  });
                                }}
                              >
                                <EditIcon sx={{ color: "#4971B2" }} />
                              </IconButton>
                              <IconButton
                                aria-label="view"
                                className="px-1 py-0"
                                onClick={() => {
                                  setDeleteModal(true);
                                  setData({ id });
                                }}
                              >
                                <DeleteIcon sx={{ color: "#ff0000" }} />
                              </IconButton>
                            </div>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={9} />
                  )}
                </tbody>
              </Table>
            </div>
            {/* {total >= 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={limit}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={(e) => setActivePage(e)}
                />
              </div>
            ) : null} */}
          </div>
        </div>
      </div>

      {/* // ********************************* Comment Modal ************************************* */}
      <ModalBox
        status={commentModal}
        onClose={() => setComment(false)}
        custom
        closeIcon={false}
        size={"sm"}
        title={"Comment"}
        description={
          <>
            <div className="form-group row mt-1">
              <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                <div className="row">
                  <div className="col-sm-12 col-form-label">
                    <TextArea
                      type="text"
                      name="comment"
                      value={comment || "No Comment Found"}
                      // placeholder="Enter comment"
                      className={`form-control `}
                      rows={4}
                      label={"Comment"}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        customizedFooter={
          <div>
            <Button
              onClick={() => setCommentModal(false)}
              {...submitButtonElement}
            >
              Close
            </Button>
          </div>
        }
      />
      {/* // ********************************* Add IP Address Modal ************************************* */}
      <ModalBox
        status={addModal}
        onClose={() => setAddModal(false)}
        custom
        // closeIcon
        size={"sm"}
        title={"Add IP Address"}
        description={
          <>
            <div className="form-group row mt-1">
              <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                <div className="row">
                  {/* <div className="col-sm-12 col-form-label">
                    <FormControlLabel
                      control={<Checkbox checked={flag} />}
                      label={"Set My IP Address"}
                      onChange={() => setFlag(!flag)}
                    />
                  </div> */}
                  <div className="col-sm-12 col-form-label">
                    <Input
                      type="text"
                      name="address"
                      onChange={(e) => {
                        setData({ ...data, [e.target.name]: e.target.value });
                      }}
                      placeholder="Enter IP Address"
                      className={`form-control`}
                      label={"IP Address"}
                      value={data.address}
                      error={errorField.address}
                      required
                    />
                    {/* <br /> */}
                    {/* <label
                      htmlFor=""
                      style={{ border: "1px solid #ccc", padding: "10px" }}
                      >
                      <span className="text-danger">Note : </span>To check your
                      IP address, open any browser and visit the URL"{" "}
                      <b> https://ipapi.co/json/ </b> "From the response, locate
                      the ip parameter; it will provide your IP address.
                    </label>
                    <label
                      htmlFor=""
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      -- Or --
                      </label>
                      <label
                      htmlFor=""
                      style={{ border: "1px solid #ccc", padding: "10px" }}
                    >
                    <span className="text-danger">Note : </span>Please Use
                      these " <b>curl ifconfig.me</b> "command in command prompt
                      and get IP Address.
                    </label> */}
                  </div>
                  <div className="col-sm-12 col-form-label">
                    <Input
                      type="text"
                      name="name"
                      onChange={(e) => {
                        setData({ ...data, [e.target.name]: e.target.value });
                      }}
                      placeholder="Enter Name"
                      className={`form-control`}
                      label={"Name"}
                      value={data.name}
                      error={errorField.name}
                      required
                    />
                  </div>
                  <div className="col-sm-12 col-form-label">
                    <TextArea
                      type="text"
                      name="comment"
                      value={data.comment}
                      onChange={(e) => {
                        setData({ ...data, [e.target.name]: e.target.value });
                      }}
                      placeholder="Enter comment"
                      className={`form-control `}
                      rows={4}
                      label={"Comment"}
                      // readOnly
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        customizedFooter={
          <div>
            <Button className="mx-2" onClick={() => setAddModal(false)}>
              Cancel
            </Button>
            <Button onClick={handleAddIpSubmit} {...submitButtonElement}>
              Submit
            </Button>
          </div>
        }
      />

      {/* // ********************************* Update IP Address Modal ************************************* */}
      <ModalBox
        status={updateModal}
        onClose={() => setUpdateModal(false)}
        custom
        // closeIcon
        size={"sm"}
        title={"Update IP Address"}
        description={
          <>
            <div className="form-group row mt-1">
              <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                <div className="row">
                  {/* <div className="col-sm-12 col-form-label">
                    <FormControlLabel
                      control={<Checkbox checked={flag} />}
                      label={"Set My IP Address"}
                      onChange={() => setFlag(!flag)}
                    />
                  </div> */}
                  <div className="col-sm-12 col-form-label">
                    <Input
                      type="text"
                      name="address"
                      onChange={(e) => {
                        setData({ ...data, [e.target.name]: e.target.value });
                      }}
                      placeholder="Enter IP Address"
                      className={`form-control`}
                      label={"IP Address"}
                      value={data.address}
                      error={errorField.address}
                      required
                    />
                    {/* <br /> */}
                    {/* <label
                      htmlFor=""
                      style={{ border: "1px solid #ccc", padding: "10px" }}
                      >
                      <span className="text-danger">Note : </span>To check your
                      IP address, open any browser and visit the URL"{" "}
                      <b> https://ipapi.co/json/ </b> "From the response, locate
                      the ip parameter; it will provide your IP address.
                    </label>
                    <label
                      htmlFor=""
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      -- Or --
                      </label>
                      <label
                      htmlFor=""
                      style={{ border: "1px solid #ccc", padding: "10px" }}
                    >
                    <span className="text-danger">Note : </span>Please Use
                      these " <b>curl ifconfig.me</b> "command in command prompt
                      and get IP Address.
                    </label> */}
                  </div>
                  <div className="col-sm-12 col-form-label">
                    <Input
                      type="text"
                      name="name"
                      onChange={(e) => {
                        setData({ ...data, [e.target.name]: e.target.value });
                      }}
                      placeholder="Enter Name"
                      className={`form-control`}
                      label={"Name"}
                      value={data.name}
                      error={errorField.name}
                      required
                    />
                  </div>
                  <div className="col-sm-12 col-form-label">
                    <TextArea
                      type="text"
                      name="comment"
                      value={data.comment}
                      onChange={(e) => {
                        setData({ ...data, [e.target.name]: e.target.value });
                      }}
                      placeholder="Enter comment"
                      className={`form-control `}
                      rows={4}
                      label={"Comment"}
                      // readOnly
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        customizedFooter={
          <div>
            <Button className="mx-2" onClick={() => setUpdateModal(false)}>
              Cancel
            </Button>
            <Button onClick={handleUpdateIpSubmit} {...submitButtonElement}>
              Submit
            </Button>
          </div>
        }
      />

      {/* ***************************** Delete Ip Address Modal ********************************** */}
      <ModalBox
        status={deleteModal}
        onClose={() => setDeleteModal(false)}
        title={"Delete IP Address"}
        size={"md"}
        custom
        description={
          selectedId.length == 1 || data?.id
            ? "Are you sure want to delete this IP address ?"
            : "Are you sure want to delete all of these this IP addresses ?"
        }
        customizedFooter={
          <div>
            <Button
              className="mx-2"
              onClick={() => {
                setDeleteModal(false);
                // setSelectedId([])
                setData({});
              }}
            >
              Cancel
            </Button>
            <Button onClick={handleIpDelete} {...submitButtonElement}>
              Delete
            </Button>
          </div>
        }
      />

      {selectedId.length > 0 && (
        <SpeedDial>
          <Fab
            size="medium"
            color="primary"
            aria-label="add"
            onClick={() => setDeleteModal(true)}
            sx={{ position: "absolute", bottom: 16, right: 16 }}
          >
            <DeleteIcon />
          </Fab>
        </SpeedDial>
      )}
    </>
  );
}
